import { Component, OnInit } from '@angular/core';
import { BillingService } from '../../../../services/billing.service';
import { LookupService } from '../../../../services/lookup.service';
import { NzCardModule } from 'ng-zorro-antd/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { UserService } from '../../../../services/user.service';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { ReportFiltersComponent } from '../report-filters/report-filters.component';

@Component({
  selector: 'ppl-batch-report',
  standalone: true,
  imports: [
    NzCardModule,
    FormsModule,
    ReactiveFormsModule,
    NzRadioModule,
    NzFormModule,
    NzSelectModule,
    NgApexchartsModule,
    NzGridModule,
    CommonModule,
    ListTableComponent,
    NzCheckboxModule,
    ReportFiltersComponent,
  ],
  templateUrl: './batch-report.component.html',
  styleUrl: './batch-report.component.css',
})
export class BatchReportComponent implements OnInit {
  programName: any;
  mcoList: any;
  batchReportData: any;
  formattedBatchReportData: any;
  mcoName: any;
  metricType: any = 'totalCharges';
  batchDate: any;
  batchDates: any;
  chartOptions: any;
  dataToDisplay: any = [];
  mcoNameSelected: any;
  claimTypes = ['All', 'SC', 'PMPM'];
  selectedClaimType = 'All';
  filteredSeries: any = [];
  allSeries: any = [];
  visibleColumns: any = [];
  checkedCount: any;
  filterFields = [
    { field: 'batchDate', show: true },
    { field: 'selectedClaimType', show: true, default: 'All' },
  ];
  selectedFilters = [
    { label: 'Total Charges', value: 'totalCharges', checked: true },
    {
      label: 'Total Timesheet Paid Amount',
      value: 'totalTimesheetPaid',
      checked: false,
    },
    {
      label: 'Adjustment Delta Charges',
      value: 'adjustmentDeltaCharges',
      checked: false,
    },
    {
      label: 'Paid Timesheet Charges',
      value: 'paidTimesheetCharges',
      checked: false,
    },
    {
      label: 'Claim Count',
      value: 'claimCount',
      checked: false,
      disabled: true,
    },
    {
      label: 'Member Count',
      value: 'memberCount',
      checked: false,
      disabled: true,
    },
  ];
  cols = [
    {
      field: 'totalCharges',
      header: 'Total Charges',
      jsonpath: 'totalCharges',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'originalClaimCharges',
      header: 'Original Claim Charges',
      jsonpath: 'originalClaimCharges',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'adjustmentClaimCharges',
      header: 'Adjustment Claim Charges',
      jsonpath: 'adjustmentClaimCharges',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'totalTimesheetPaid',
      header: 'Total Timesheet Paid Amount',
      jsonpath: 'totalTimesheetPaid',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'claimCount',
      header: 'Claim Count',
      jsonpath: 'claimCount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'originalClaimCount',
      header: 'Original Claim Count',
      jsonpath: 'originalClaimCount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'adjustmentClaimCount',
      header: 'Adjustment Claim Count',
      jsonpath: 'adjustmentClaimCount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'memberCount',
      header: 'Member Count',
      jsonpath: 'memberCount',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'adjustmentDeltaCharges',
      header: 'Adjustment Delta Charges',
      jsonpath: 'adjustmentDeltaCharges',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidTimesheetCharges',
      header: 'Paid Timesheet Charges',
      jsonpath: 'paidTimesheetCharges',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  constructor(
    private lookupService: LookupService,
    private billingService: BillingService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    const navigationState = window.history.state;
    if (navigationState.mco) {
      this.mcoNameSelected = navigationState.mco;
    }
    if (navigationState.pmpm) {
      this.selectedClaimType = navigationState.pmpm;
    }
    this.billingService
      .getBatchDates(this.programName)
      .subscribe((data: any) => {
        this.batchDates = data.responsedata.date;
        this.batchDate =
          navigationState && navigationState.type
            ? navigationState.type
            : this.batchDates && this.batchDates[0];
        // this.getBatchReportData();
        this.filterFields = [
          { field: 'batchDate', show: true, default: this.batchDate },
          { field: 'selectedClaimType', show: true, default: 'All' },
        ];
      });
    this.updateVisibleColumns();
  }

  updateFilterStates() {
    const groups = {
      amount: [
        'totalCharges',
        'totalTimesheetPaid',
        'adjustmentDeltaCharges',
        'paidTimesheetCharges',
      ],
      count: ['claimCount', 'memberCount'],
    };

    const checkedSet = new Set(
      this.selectedFilters.filter((f) => f.checked).map((f) => f.value)
    );

    const activeGroup = [...groups.amount].some((val) => checkedSet.has(val))
      ? 'amount'
      : [...groups.count].some((val) => checkedSet.has(val))
      ? 'count'
      : null;

    this.selectedFilters = this.selectedFilters.map((filter) => {
      const inAmountGroup = groups.amount.includes(filter.value);
      const inCountGroup = groups.count.includes(filter.value);

      let disabled = false;

      if (activeGroup === 'amount' && inCountGroup) disabled = true;
      else if (activeGroup === 'count' && inAmountGroup) disabled = true;

      return { ...filter, disabled };
    });
  }

  filterChanged(change: any) {
    this.selectedClaimType = change.formValues.selectedClaimType;
    this.batchDate = change.formValues.batchDate;
    if (change.field === 'batchDate' || change.field === 'selectedClaimType') {
      this.onFilterChange();
    } else {
      return;
    }
  }

  updateVisibleColumns(): void {
    const selectedFields = this.selectedFilters
      .filter((filter) => filter.checked)
      .map((filter) => filter.value);
    const visibleFieldNames = [...selectedFields];
    if (visibleFieldNames.includes('claimCount')) {
      visibleFieldNames.push('originalClaimCount', 'adjustmentClaimCount');
    }
    if (visibleFieldNames.includes('totalCharges')) {
      visibleFieldNames.push('originalClaimCharges', 'adjustmentClaimCharges');
    }
    this.visibleColumns = this.cols.filter((col) =>
      visibleFieldNames.includes(col.field)
    );
    const metricColumn = {
      field: 'mcoName',
      header: 'MCO',
      jsonpath: 'mcoName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    };
    this.visibleColumns.unshift(metricColumn);
  }

  onCheckboxChange(selected: any) {
    const selectedIds = selected
      .filter((item: any) => item.checked)
      .map((item: any) => item.value);

    let actualIds = [...selectedIds];
    if (selectedIds.includes('claimCount')) {
      actualIds = actualIds.filter((id) => id !== 'claimCount');
      actualIds.push('originalClaimCount', 'adjustmentClaimCount');
    }
    if (selectedIds.includes('totalCharges')) {
      actualIds = actualIds.filter((id) => id !== 'totalCharges');
      actualIds.push('originalClaimCharges', 'adjustmentClaimCharges');
    }
    this.checkedCount = actualIds.length;
    if (this.checkedCount) {
      this.updateChart(actualIds);
    }
    this.updateFilterStates();
    this.updateVisibleColumns();
  }

  updateChart(type: any) {
    this.filteredSeries = this.allSeries.filter((series: any) =>
      type.includes(series.id)
    );
    this.chartOptions = {
      ...this.chartOptions,
      series: [...this.filteredSeries],
      plotOptions: {
        ...this.chartOptions.plotOptions,
        bar: {
          ...this.chartOptions.plotOptions?.bar,
          columnWidth:
            this.checkedCount === 1
              ? '40%'
              : this.checkedCount === 2
              ? '50%'
              : '70%',
        },
      },
      title: {
        text: '',
      },
      subtitle: {
        text: this.getTitle(),
        align: 'right',
        style: {
          fontSize: '14px',
          fontWeight: 600,
          whiteSpace: 'pre-line',
        },
      },
    };
  }

  createAllSeries() {
    this.allSeries = [
      {
        name: 'Total Charges',
        data: this.batchReportData?.map((item: any) => item.totalCharges),
        id: 'totalCharges',
      },
      {
        name: 'Claim Count',
        data: this.batchReportData?.map((item: any) => item.claimCount),
        id: 'claimCount',
        group: 'claimStack',
      },
      {
        name: 'Original Claim Count',
        data: this.batchReportData?.map((item: any) => item.originalClaimCount),
        id: 'originalClaimCount',
        group: 'claimStack',
      },
      {
        name: 'Adjustment Claim Count',
        data: this.batchReportData?.map(
          (item: any) => item.adjustmentClaimCount
        ),
        id: 'adjustmentClaimCount',
        group: 'claimStack',
      },
      {
        name: 'Member Count',
        data: this.batchReportData?.map((item: any) => item.memberCount),
        id: 'memberCount',
        group: 'memberStack',
      },
      {
        name: 'Total Timesheet Paid Amount',
        data: this.batchReportData?.map((item: any) => item.totalTimesheetPaid),
        id: 'totalTimesheetPaid',
        group: 'timesheetAmountStack',
      },
      {
        name: 'Timesheet Paid Charges',
        data: this.batchReportData?.map(
          (item: any) => item.paidTimesheetCharges
        ),
        id: 'paidTimesheetCharges',
        group: 'timesheetChargesStack',
      },
      {
        name: 'Adjustment Delta Charges',
        data: this.batchReportData?.map(
          (item: any) => item.adjustmentDeltaCharges
        ),
        id: 'adjustmentDeltaCharges',
        group: 'deltaStack',
      },
      {
        name: 'Original Claim Charges',
        data: this.batchReportData?.map(
          (item: any) => item.originalClaimCharges
        ),
        id: 'originalClaimCharges',
        group: 'totalChargesStack',
      },
      {
        name: 'Adjustment Claim Charges',
        data: this.batchReportData?.map(
          (item: any) => item.adjustmentClaimCharges
        ),
        id: 'adjustmentClaimCharges',
        group: 'totalChargesStack',
      },
    ];
  }

  getBatchReportData() {
    const payload = {
      reportName: 'BatchSummaryReport',
      reportBy: null,
      mcoName: this.mcoNameSelected,
      claimType: this.selectedClaimType,
      programCode: this.programName,
      batchDate: this.batchDate,
    };
    this.billingService.getBatchReportData(payload).subscribe((data: any) => {
      this.batchReportData = data.responsedata || [];
      this.formattedBatchReportData = this.batchReportData.map((item: any) => ({
        ...item,
        totalCharges: this.billingService.formatCurrency(item.totalCharges),
        totalTimesheetPaid: this.billingService.formatCurrency(
          item.totalTimesheetPaid
        ),
        originalClaimCharges: this.billingService.formatCurrency(
          item.originalClaimCharges
        ),
        adjustmentClaimCharges: this.billingService.formatCurrency(
          item.adjustmentClaimCharges
        ),
        adjustmentDeltaCharges: this.billingService.formatCurrency(
          item.adjustmentDeltaCharges
        ),
        paidTimesheetCharges: this.billingService.formatCurrency(
          item.paidTimesheetCharges
        ),
        originalClaimCount: item.originalClaimCount.toLocaleString('en-US'),
        adjustmentClaimCount: item.adjustmentClaimCount.toLocaleString('en-US'),
        claimCount: item.claimCount.toLocaleString('en-US'),
        memberCount: item.memberCount.toLocaleString('en-US'),
      }));
      this.createAllSeries();
      // this.onDisplayByChange();
      this.fetchChartOptions();
      this.onCheckboxChange(this.selectedFilters);
    });
  }

  onDisplayByChange() {
    if (this.metricType === 'totalCharges') {
      this.dataToDisplay = this.batchReportData?.map(
        (item: any) => item.totalCharges
      );
    } else if (this.metricType === 'claimCount') {
      this.dataToDisplay = this.batchReportData?.map(
        (item: any) => item.claimCount
      );
    } else {
      this.dataToDisplay = this.batchReportData?.map(
        (item: any) => item.memberCount
      );
    }
    // this.setCategories();
    this.fetchChartOptions();
  }

  getTotal(metricType: string): string {
    const total = this.batchReportData?.reduce((sum: any, item: any) => {
      const value = +item[metricType] || 0;
      return sum + value;
    }, 0);

    return metricType === 'totalCharges'
      ? `$${total.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : total.toLocaleString();
  }

  getTitle() {
    const moneyFilters = [
      'totalCharges',
      'totalTimesheetPaid',
      'adjustmentDeltaCharges',
      'paidTimesheetCharges',
    ];
    const checkedFilters = this.selectedFilters.filter((f) => f.checked);
    const totalLines = checkedFilters.map((filter) => {
      const series = this.allSeries.find((s: any) => s.id === filter.value);
      const total =
        series?.data?.reduce((sum: number, val: any) => {
          if (val == null || val === '') return sum;
          const numeric =
            typeof val === 'string'
              ? parseFloat(val.replace(/,/g, '').trim())
              : +val;
          return sum + (isNaN(numeric) ? 0 : numeric);
        }, 0) || 0;
      const formattedTotal = moneyFilters.includes(filter.value)
        ? this.billingService.formatCurrency(total)
        : total.toLocaleString();
      return `${filter.label}: ${formattedTotal}`;
    });
    return totalLines.join(' | ');
  }

  fetchChartOptions() {
    this.chartOptions = {
      series: [],
      chart: {
        type: 'bar',
        height: 450,
        stacked: true,
        width: Math.max(this.batchReportData.length * 35, 750),
        offsetY: 20,
      },
      title: {
        text: '',
      },
      subtitle: {
        text: this.getTitle(),
        align: 'right',
        style: {
          fontSize: '14px',
          fontWeight: 600,
          whiteSpace: 'pre-line',
        },
      },
      noData: {
        text: 'No data available',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          color: '#999',
          fontSize: '16px',
          fontFamily: 'Arial',
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '40%',
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: this.batchReportData?.map((item: any) => item.mcoName),
        title: {
          text: 'MCO',
        },
        labels: {
          show: true,
          rotate: -45,
          hideOverlappingLabels: false,
        },
      },
      yaxis: {
        title: {
          // text: this.yaxisText,
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        enabled: true,
        followCursor: true,
        y: {
          formatter: (value: number, opts: any) => {
            const seriesName = opts.w.config.series[opts.seriesIndex]?.name;
            if (seriesName.toLowerCase().includes('count')) {
              return value.toLocaleString();
            } else {
              return this.billingService.formatCurrency(value);
            }
          },
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: -25,
      },
      responsive: [
        {
          breakpoint: 768, // applies when screen width <= 768px
          options: {
            chart: {
              height: 300,
            },
            legend: {
              position: 'bottom',
            },
            xaxis: {
              labels: {
                rotate: -45,
                style: {
                  fontSize: '10px',
                },
              },
            },
            dataLabels: {
              style: {
                fontSize: '6px',
              },
            },
          },
        },
      ],
    };
  }

  onFilterChange() {
    this.getBatchReportData();
  }
}
